import * as Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import vClickOutside from "click-outside-vue3";
import DChooseParams from "@components/organisms/DChooseParams.vue";
import VueSmoothScroll from "vue3-smooth-scroll";
import Notifications from '@kyvg/vue3-notification';
import velocity from 'velocity-animate'

$(window).on('load', function(e) {
  const mountEl = document.querySelector('#choose');
  const app = Vue.createApp(DChooseParams, {...mountEl.dataset});
  app.use(VueAxios, axios).use(VueSmoothScroll).use(vClickOutside).use(Notifications, { velocity });
  app.mount('#choose');
})
